import { Colors, Icon } from '@mercator-gcp/grout';
import Tooltip from 'components/elements/Tooltip';

type TProps = {
  label: string;
};

/* This element is used to display extra information to a user */
const InfoMarker = ({ label }: TProps) => {
  return (
    <Tooltip tooltipText={label}>
      <Icon fill={Colors.TextQuiet} name={Icon.Name.InfoQuestionMark} />
    </Tooltip>
  );
};

export default InfoMarker;
